// https://www.iso.org/iso-4217-currency-codes.html
export enum Currency {
  JPY = 'jpy',
  USD = 'usd',
}
